export default __webpack_public_path__ + "media/zurb/img/events/rsvp/event-rsvp-location-icon-6f3aa88e79f6a1e031c5a822757b9425.svg";